import { render, staticRenderFns } from "./ChangeBID.vue?vue&type=template&id=0e726c18&"
import script from "./ChangeBID.vue?vue&type=script&lang=js&"
export * from "./ChangeBID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports